var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CategoryScale, Chart as ChartJS, LinearScale, LineElement, PointElement, Title, Tooltip, } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Line } from 'react-chartjs-2';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, ChartDataLabels);
var DesigningChart = function (_a) {
    var _b, _c;
    var graphSeries = _a.graphSeries;
    var chartData = {
        labels: (_c = (_b = graphSeries[0]) === null || _b === void 0 ? void 0 : _b.data.map(function (point) { return String(point.x); })) !== null && _c !== void 0 ? _c : [],
        datasets: graphSeries.map(function (series) {
            var isInSitu = series.label.toLowerCase().includes('in situ');
            var baseColor = isInSitu ? '#000000' : '#3b82f6';
            var backgroundColor = isInSitu ? 'rgba(0, 0, 0, 0.1)' : 'rgba(59, 130, 246, 0.2)';
            var borderDash = isInSitu ? [5, 5] : undefined;
            return {
                label: series.label,
                data: series.data.map(function (point) { return point.y; }),
                borderColor: baseColor,
                backgroundColor: backgroundColor,
                borderWidth: 3,
                pointBackgroundColor: baseColor,
                pointRadius: 3,
                pointHoverRadius: 5,
                tension: 0.3,
                fill: !isInSitu,
                borderDash: borderDash,
            };
        }),
    };
    var allValues = graphSeries.flatMap(function (s) { return s.data.map(function (p) { return p.y; }); });
    var maxY = Math.max.apply(Math, __spreadArray(__spreadArray([], allValues, false), [0], false));
    var options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
                align: 'start',
                labels: {
                    boxWidth: 20,
                    padding: 16,
                    font: {
                        size: 12,
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        var value = context.raw;
                        return "Rw: ".concat(value);
                    },
                },
            },
            datalabels: {
                anchor: 'end',
                align: 'top',
                color: function (ctx) { return ctx.dataset.borderColor; },
                font: {
                    weight: 'bold',
                    size: 10,
                },
                formatter: function (value) { return "".concat(value); },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Frequency (Hz)',
                    font: {
                        size: 12,
                        weight: 'bold',
                    },
                },
                grid: {
                    display: true,
                    color: 'rgba(0, 0, 0, 0.1)',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Rw',
                    font: {
                        size: 12,
                        weight: 'bold',
                    },
                },
                min: 0,
                max: maxY + 10,
                ticks: {
                    stepSize: 5,
                },
                grid: {
                    display: true,
                    color: 'rgba(0, 0, 0, 0.1)',
                },
            },
        },
    };
    return (_jsx("div", __assign({ className: "h-[500px] w-full" }, { children: _jsx(Line, { data: chartData, options: options }) })));
};
export default DesigningChart;
